import "./header.css";
import logo from "./assets/Logo-Gerais-Branco.png";

const Header = () => {
    return (
        <div className="header-container">
            <a href="#" className="logo-container">
                <img src={logo} alt="Gerais Net Logo"  className="logo-img"  />
                
            </a>

            <button className="mobile-menu-btn">
                <i className="fas fa-bars"></i>
            </button>

            <nav className="nav-menu">
                <ul className="nav-links">
                    <li>
                        <a href="#planos" className="nav-link">
                            Planos de Internet
                        </a>
                    </li>
                    <li>
                        <a href="#sobre" className="nav-link">
                            Sobre a Empresa
                        </a>
                    </li>
                </ul>

                <a href="https://geraisnet.ispfycloud.com.br/" className="btn-assinante">
                    <i className="fas fa-user-circle"></i>
                    Central do Assinante
                </a>
            </nav>
        </div>
    );
};

export default Header;
